
var $body,
    $postGrid,
    $showMore,
    $filterInput,
    $postIntegrations,
    $noResults;

var loadMoreAmount = 12;


$(document).ready(function($) {

  $showMore    = $('.js-show-more');
  $postGrid    = $('.js-post-grid');
  $filterInput = $('.js-input-filter');
  $postIntegrations = $('.js-post-integration');
  $noResults = $('.js-no-results');

  $showMore.click(function(event) {
    event.preventDefault();
    showNextPosts();
  });

  $filterInput.keyup(function() {
    var input = $(this).val();
    i = new RegExp("" + input,"i");
    var count = 0;
    $postIntegrations.each(function(){
      var check = i.test($(this).data("title"));
      $(this).toggle(check);
      if (check) {
        count ++;
      }
    });

    var hasResult = count > 0;
    $noResults.toggle(!hasResult);

    $showMore.hide();
  });
});


// Functions

function showNextPosts() {
  $hiddenPosts = $('.c-post--integration.is-hidden');
  $hiddenPosts.slice(0,loadMoreAmount).show().removeClass('is-hidden');

  if ($hiddenPosts.length <= loadMoreAmount ) {
    $showMore.hide();
  }
}

